import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getOpenMarketProducts,
  IGetOpenMarketProductsParams,
} from '../../../../api/product/queries/getOpenMarketProducts';
import { IOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';

interface IUseGetSellProductsQueryParams extends IGetOpenMarketProductsParams {
  options?: UseQueryOptions<IOpenMarketProduct[], AxiosError>;
}

export const useGetOpenMarketProductsQuery = ({ searchParam, options }: IUseGetSellProductsQueryParams) => {
  return useQuery<IOpenMarketProduct[], AxiosError>(
    [
      'user-sell-tractors',
      `status=${searchParam?.status}`,
      `count=${searchParam?.count}`,
      `machineType=${searchParam?.machineType}`,
      `machineId=${searchParam?.machineId}`,
      `brand=${searchParam?.brand}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `minPrice=${searchParam?.minPrice}`,
      `maxPrice=${searchParam?.maxPrice}`,
      `sort=${searchParam?.sort}`,
      `rowConfig=${searchParam?.rowConfig}`,
    ],
    () => getOpenMarketProducts({ searchParam }),
    options,
  );
};
